type FormatWonToEokOptions = {
  /**
   * 소수점 최대 자리수
   * 예: 2 => 123.456 -> 123.46
   */
  fractionDigits?: number;

  /**
   * 콤마 사용 여부
   * true  => 12,345.68
   * false => 12345.68
   */
  comma?: boolean;

  /**
   * 반환 타입
   * number => 숫자 반환
   * string => 문자열 반환
   */
  returnType?: 'number' | 'string';

  /**
   * null, undefined, '', NaN일 때 반환할 값
   */
  emptyValue?: string | number | null;
};

export const formatWonToEok = (
  value: string | number | null | undefined,
  options: FormatWonToEokOptions = {}
): string | number | null => {
  const { fractionDigits, comma = true, returnType = 'string', emptyValue = '' } = options;
  if (value === null || value === undefined || value === '' || value === 0 || value === '0') {
    return emptyValue;
  }

  const num = Number(value);

  if (Number.isNaN(num)) {
    return emptyValue;
  }

  const eokValue = num / 100000000;

  if (returnType === 'number') {
    // number 타입일 때만 Number 변환
    return typeof fractionDigits === 'number' ? Number(eokValue.toFixed(fractionDigits)) : eokValue;
  }

  if (comma) {
    return eokValue.toLocaleString('ko-KR', {
      minimumFractionDigits: fractionDigits ?? 0,
      maximumFractionDigits: fractionDigits ?? 20,
    });
  }

  const rtn =
    typeof fractionDigits === 'number' ? eokValue.toFixed(fractionDigits) : String(eokValue);
  return rtn;
};

export const convertNull = (obj: object) => {
  for (const prop in obj) {
    if (obj[prop] === null) {
      obj[prop] = '';
    }
  }
  return obj;
};

export const formatBytes = (bytes = 0, decimals = 2) => {
  if (bytes === 0) return '0KB'; // 0 Bytes

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))}${sizes[i]}`;
};

export const fileExtension = (fileName) => {
  const ext = fileName.match(/\.([^.]+)$/)?.[1];

  let r = 'docu';
  if (ext === 'xls' || ext === 'xlsx') {
    r = 'excel';
  } else if (ext === 'doc' || ext === 'docx') {
    r = 'word';
  } else if (ext === 'png' || ext === 'jpg' || ext === 'bmp' || ext === 'gif') {
    r = 'img';
  } else if (ext === 'ppt' || ext === 'pptx') {
    r = 'ppt';
  } else if (ext === 'html' || ext === 'js') {
    r = 'mark';
  } else if (ext === 'zip') {
    r = 'zip';
  }
  return r;
};

/**
 * string -> json 변환
 * @param str
 */
export const convertJson = (str?: string) => {
  if (str) {
    try {
      // TODO CommonUtil unescapeHtml 사용 예정
      const o = JSON.parse(str.replaceAll('&quot;', '"'));
      if (o && typeof o === 'object') {
        return o;
      }
    } catch (e) {
      return str;
    }
  }
  return str;
};
